import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { promotionKeys } from "./query-keys";

export function useDeletePromotion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const { error } = await apiClient.DELETE("/v1/promotions/{id}", {
        params: { path: { id } },
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: promotionKeys.all });
    },
  });
}
